/**
 * ReportsHarvestInspectionsPersonLastName
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectReportsHarvestInspectionsPersonValue } from '../../services/reportsHarvestInspectionsPeople/selectors';

interface Props {
    personLastName?: ?string;
}

export class ReportsHarvestInspectionsPersonLastName extends React.PureComponent<Props> {
    render() {
        const { personLastName } = this.props;
        if (!personLastName) return null;
        return personLastName;
    }
}

const mapStateToProps = createStructuredSelector({
    personLastName: makeSelectReportsHarvestInspectionsPersonValue(
        'personLastName'
    )
});

export default connect(mapStateToProps)(
    ReportsHarvestInspectionsPersonLastName
);
